import Modal from 'bootstrap/js/dist/modal';
import CustomerEmailCapturedEvent from '../../events/customer-email-captured-event';

(function () {
    const loginLink = document.getElementById('login-link');
    const loginModal = document.getElementById('login-modal');

    if (loginLink && loginModal) {
        const modal = new Modal(loginModal);

        loginLink.addEventListener('click', (e) => {
            e.preventDefault();
            modal.show();
        });
    }

    const loginButtons = document.querySelectorAll('form[action="/login-check"] button[type="submit"]');

    loginButtons.forEach((button) => {
        button.addEventListener('click', onSubmitButtonClick);
    });

    function onSubmitButtonClick(event) {
        const emailInput = event.target.closest('form').querySelector('input[name="_username"]');
        if (emailInput && typeof emailInput.value === 'string' && emailInput.value.trim() !== '') {
            document.dispatchEvent(new CustomerEmailCapturedEvent(emailInput.value));
        }
    }
})();
